import React from 'react'
import { useTranslation } from 'react-i18next'
import { FieldHookConfig, useField } from 'formik'
import { ColorPicker as UIColorPicker } from '@carsys/ui'
import { isInvalid } from './utils'
import { useRegisterFormField } from './TabbedForm/FormTabPanel'

interface ColorPickerProps
  extends Omit<React.ComponentProps<typeof UIColorPicker>, 'component' | 'defaultChecked' | 'defaultValue' | 'name' | 'value'>,
    Pick<FieldHookConfig<string>, 'name' | 'validate'> {}

export function ColorPicker({ name, validate, ...props }: ColorPickerProps) {
  const { t, i18n } = useTranslation()
  const [input, meta] = useField<string>({ name, validate })

  const metaError = i18n.exists(meta.error!) ? t(meta.error!) : meta.error
  const propsHelperText = i18n.exists(String(props.helperText!)) ? t(String(props.helperText!)) : props.helperText

  useRegisterFormField(name)

  return (
    <UIColorPicker
      id={input.name}
      error={isInvalid(meta)}
      {...props}
      {...input}
      helperText={isInvalid(meta) ? metaError : propsHelperText}
    />
  )
}
